// extracted by mini-css-extract-plugin
module.exports = {"success_action":"a10a3f92e9--success_action--1o80m"};